export const ERROR_REJECTED_IMAGE =
  'Filen måste vara av typen jpeg, jpg eller png och max 2mb stor.';
export const ERROR_CORRUPT_IMAGE =
  'Det gick inte att öppna den valda bilden, vänligen testa igen.';

export const ERROR_REQUIRED = 'Obligatorisk';
export const ERROR_MAX_LENGTH_30 = 'Max 30 tecken';
export const ERROR_MAX_LENGTH_50 = 'Max 50 tecken';
export const ERROR_EMAIL_FORMAT = 'Ange en giltig mailadress';
